import './workerProfileCompact.css';
import ManualWorkLinks from './ManualWorkLinks';
import { Link as RouterLink } from 'react-router-dom';
import { useWorkerProfile } from 'src/workspaces/workerProfile/WorkerProfileContext';
import * as React from 'react';
import { Box, Card, IconButton, Stack, Typography } from '@mui/material';
import { Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import { useLocation, useNavigate } from 'react-router';
import PersonalInformation from './contractorDetailTabs/personalInformation/info';
import JobHistory from './contractorDetailTabs/jobHistory';
import AttendanceDetail from './contractorDetailTabs/AttendanceDetail';

import ContractorCalender from './contractorDetailTabs/contractorCalender';
import ActivityLogs from './contractorDetailTabs/ActivityLogs';
import Reviews from './contractorDetailTabs/reviews';
import CredentialsSection from './contractorDetailTabs/credentials/CredentialsSection';
import ContractorDocuments from './contractorDetailTabs/documents';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

interface LocationState {
  tab?: string;
}

export default function LabTabs() {
  const scope = useWorkerProfile();
  const location = useLocation();
  const navigate = useNavigate();

  const requestedTab = (location.state as LocationState)?.tab ?? new URLSearchParams(location.search).get('tab');
  const initialTabValue = requestedTab === '5' ? '5' : '3';
  const [value, setValue] = React.useState(initialTabValue);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <Box className={scope ? "company-worker-profile-compact" : undefined} sx={{ padding: 2, width: '100%', typography: 'body1', height: '100%', overflow: 'auto' }}>
      <TabContext value={value}>
        <Card>
          <Stack padding={1} direction="row" alignItems="center" gap={2}>
            {scope ? <IconButton component={RouterLink} to={scope.returnTo ?? `/companies/${scope.companyId}/workers`} aria-label="Back to company workers"><KeyboardBackspaceIcon /></IconButton> : <KeyboardBackspaceIcon
              onClick={() => navigate(-1)}
              sx={{ cursor: 'pointer' }}
            />}
            <Typography sx={{ fontSize: 16, fontWeight: 'bold' }}>
              Contractor Profile
            </Typography>
          </Stack>

          <PersonalInformation />
          <CredentialsSection />
          <ManualWorkLinks />
          <TabList
            textColor="inherit"
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              '& .MuiTabs-indicator': {
                backgroundColor: '#F7A408',
                height: 3
              }
            }}
            onChange={handleChange}
            aria-label="contractor profile tabs"
          >
            <Tab
              sx={{ color: value === '3' ? '#F7A408' : 'gray', fontSize: 12 }}
              label="Calendar"
              value="3"
            />
            <Tab
              sx={{ color: value === '5' ? '#F7A408' : 'gray', fontSize: 12 }}
              label="Documents"
              value="5"
              data-testid="contractor-tab-documents"
            />
          </TabList>
          <TabPanel sx={{ padding: 0 }} value="3">
            <ContractorCalender />
          </TabPanel>
          <TabPanel sx={{ padding: 2 }} value="5">
            <ContractorDocuments />
          </TabPanel>
          {/* <TabList
            textColor="inherit"
            sx={{
              '& .MuiTabs-indicator': {
                backgroundColor: '#F7A408',
                height: 3
              }
            }}
            onChange={handleChange}
            aria-label="lab API tabs example"
          >
            <Tab
              sx={{ color: value === '3' ? '#F7A408' : 'gray', fontSize: 12 }}
              label="Contractor Calender"
              value="3"
            /> */}
            {/* <Tab
              sx={{ color: value === '1' ? '#F7A408' : 'gray', fontSize: 12 }}
              label="Job History"
              value="1"
            /> */}

            {/* <Tab
              sx={{ color: value === '2' ? '#F7A408' : 'gray', fontSize: 12 }}
              label="Reviews"
              value="2"
            /> */}

            {/* <Tab
              sx={{ color: value === '4' ? '#F7A408' : 'gray', fontSize: 12 }}
              label="Activity Log"
              value="4"
            /> */}
          {/* </TabList> */}
          {/* <TabPanel sx={{ padding: 0 }} value="3">
            <ContractorCalender />
          </TabPanel> */}
          {/* <TabPanel sx={{ padding: 0 }} value="1">
            <JobHistory />
          </TabPanel> */}
          {/* 
          <TabPanel sx={{ padding: 0 }} value="2">
            <Reviews />
          </TabPanel> */}

          {/* <TabPanel sx={{ padding: 0 }} value="4">
            <ActivityLogs />
          </TabPanel> */}
        </Card>
      </TabContext>
    </Box>
  );
}
